import React from 'react';
import {Outlet} from 'react-router-dom';
import AdminLayout from "../../../layout/admin/AdminLayout";

const Tiles: React.FC = () => {
  return (
    <AdminLayout>
      <Outlet/>
    </AdminLayout>
  );
};

export default Tiles;

